import React from 'react';
import logoImg from '../../assets/images/roulette-logo.png';


const GameLogo = () =>{
  return (
    <div className='roulette-logo'>
      <span>
        <img src={logoImg} alt='' />
      </span>
    </div>
  )
};
export default GameLogo
